/* DS Gordijnrail Configurator — Shopify AJAX Cart integration */
(function () {
  'use strict';

  const P = window.RULLENS_PRODUCTS || {};

  const MODELS = {
    'recht':    { letter: 'A', label: 'Geen bochten',                  sides: ['A'],         bochten: 0 },
    'u-voor':   { letter: 'B', label: 'Links en rechts naar voren',    sides: ['A','B','C'], bochten: 2 },
    'u-achter': { letter: 'C', label: 'Links en rechts naar achteren', sides: ['A','B','C'], bochten: 2 },
    'r-voor':   { letter: 'D', label: 'Rechts naar voren',             sides: ['A','B'],     bochten: 1 },
    'r-achter': { letter: 'E', label: 'Rechts naar achteren',          sides: ['A','B'],     bochten: 1 },
    'l-voor':   { letter: 'F', label: 'Links naar voren',              sides: ['A','B'],     bochten: 1 },
    'l-achter': { letter: 'G', label: 'Links naar achteren',           sides: ['A','B'],     bochten: 1 },
  };

  let STEPS = ['model', 'afmetingen', 'bevestiging', 'glijders', 'eindkapjes'];

  const S = {
    kleur: Object.keys(P.rail || {})[0] || 'zwart',
    model: 'recht',
    modelGekozen: false,
    bevGekozen: false,
    glijderGekozen: false,
    ekGekozen: false,
    ekWil: true,
    steunVariantId: null,
    steunPrijs: 1.49,
    steunLabel: 'Plafondsteun',
    glijderProductIdx: 0,
    glijderType: 'ks',
    glijderVariantId: null,
    glijderPrijs: 0,
    glijderLabel: '',
    glijderOpening: 'midden',
    ek: 2,
    confirmed: {},
  };

  if (P.bevestiging_default && P.bevestiging_default.variantId) {
    S.steunVariantId = P.bevestiging_default.variantId;
    S.steunPrijs = P.bevestiging_default.price / 100;
    S.steunLabel = P.bevestiging_default.label;
  }

  const _gp = P.glijder_producten;
  if (_gp && _gp.length > 0) {
    const first = _gp[0];
    S.glijderType = first.type || 'ks';
    S.glijderLabel = first.title;
    if (first.variants && first.variants.length > 0) {
      S.glijderVariantId = first.variants[0].id;
      S.glijderPrijs = first.variants[0].price / 100;
    }
  } else if (P.glijder_default && P.glijder_default.variantId) {
    S.glijderVariantId = P.glijder_default.variantId;
    S.glijderPrijs = P.glijder_default.price / 100;
    S.glijderLabel = P.glijder_default.label;
  }

  const fmt = n => '€ ' + n.toFixed(2).replace('.', ',');
  const nl2 = n => n.toFixed(2).replace('.', ',');
  const $ = id => document.getElementById(id);

  /* ── ACCORDION ── */

  function openStep() {}
  function toggleStep() {}

  function confirmStep(step) {
    S.confirmed[step] = true;
    updateDots();
    updateAllSumms();
    calc();
  }

  function updateDots() {
    STEPS.forEach(step => {
      const el = document.querySelector(`[data-step="${step}"]`);
      if (!el) return;
      const dot = el.querySelector('.gr-dot');
      if (!dot) return;
      const isOpen = el.classList.contains('open');
      const isDone = S.confirmed[step];
      dot.dataset.state = isOpen ? 'active' : (isDone ? 'done' : 'default');
    });
  }

  function updateAllSumms() {
    const modelEl = $('summModel');
    if (modelEl) modelEl.textContent = MODELS[S.model].label;

    const afmEl = $('summAfmetingen');
    if (afmEl) afmEl.textContent = getTotalLength() + ' cm';

    const bevEl = $('summBevestiging');
    if (bevEl) bevEl.textContent = (S.steunLabel || '—').split('—')[0].trim() || '—';

    const glEl = $('summGlijders');
    if (glEl) glEl.textContent = (S.glijderLabel || '—').split(' (')[0].trim() || '—';

    const ekSumEl = $('summEindkapjes');
    if (ekSumEl) {
      const nEK = parseInt($('ekInput')?.value) || 2;
      const ckA = $('ckAssemblage')?.checked;
      ekSumEl.textContent = nEK + ' eindkapjes' + (ckA ? ' · Kant-en-klaar' : '');
    }
  }

  /* ── SELECTORS ── */

  function getTotalLength() {
    const mc = MODELS[S.model];
    let total = 0;
    mc.sides.forEach(s => {
      const el = $('lengte' + s + 'Input');
      if (el) total += Math.max(0, parseInt(el.value) || 0);
    });
    return Math.max(30, total);
  }

  function filterBevestigingByColor(kleur) {
    document.querySelectorAll('#mBevestiging .gr-bev-item[data-color]').forEach(function(item) {
      const c = item.dataset.color;
      item.style.display = (c === '' || c === kleur) ? '' : 'none';
    });
  }

  function updateGlijderImages(kleur) {
    const colorAliases = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] };
    const alts = colorAliases[kleur] || [kleur];
    document.querySelectorAll('.gr-bev-item[data-glidx]').forEach(function(item) {
      const idx = parseInt(item.dataset.glidx);
      const gp = (P.glijder_producten || [])[idx];
      if (!gp) return;
      const imgUrl = alts.reduce((found, a) => found || (gp.colorImages && gp.colorImages[a]), null) || gp.image;
      if (!imgUrl) return;
      const img = item.querySelector('.gr-bev-img img');
      if (img) { img.src = imgUrl; img.srcset = ''; }
    });
  }

  function setEindkapje(wantsEk, el) {
    S.ekGekozen = true;
    S.ekWil = wantsEk;
    document.querySelectorAll('#mEindkapjes .gr-bev-item').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const det = $('ekDetails');
    if (det) det.style.display = wantsEk ? '' : 'none';
    closeModal('mEindkapjes');
    calc();
  }

  function setMontage(wantsMontage) {
    const ck = $('ckMontage');
    if (ck) ck.checked = wantsMontage;
    const btnJa  = $('btnMontageJa');
    const btnNee = $('btnMontageNee');
    if (btnJa)  btnJa.classList.toggle('active', wantsMontage);
    if (btnNee) btnNee.classList.toggle('active', !wantsMontage);
    const summ = $('summMontage');
    if (summ) summ.textContent = wantsMontage ? 'Toegevoegd' : 'Niet toegevoegd';
    calc();
  }

  function updateEindkapjeImage(kleur) {
    const alts = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] }[kleur] || [kleur];
    const variants = P.eindkapje?.variants || [];
    const match = variants.find(v => { const vt = v.title.toLowerCase(); return alts.some(a => vt.includes(a)); })
      || variants[0];
    if (!match?.image) return;
    const img = document.querySelector('#mEindkapjes .gr-bev-img img');
    if (img) { img.src = match.image; img.srcset = ''; }
  }

  function setKleur(v) {
    S.kleur = v;
    document.querySelectorAll('.gr-sw').forEach(e => e.classList.remove('active'));
    const btn = document.querySelector('.gr-sw-' + v);
    if (btn) btn.classList.add('active');
    const railData = P.rail?.[v];
    if (railData?.id) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', railData.id);
      history.replaceState({}, '', url.toString());
    }
    if (railData?.image) {
      const el = $('grMainImg');
      if (el) { el.src = railData.image; el.srcset = ''; }
      window.GR_IMG_IDX = 0;
      document.querySelectorAll('.gr-thumb').forEach(t => t.classList.toggle('active', t.dataset.idx === '0'));
    }
    filterBevestigingByColor(v);
    updateGlijderImages(v);
    updateEindkapjeImage(v);
    calc();
  }

  function setModel(v) {
    S.model = v;
    const mc = MODELS[v];
    document.querySelectorAll('.gr-model-card').forEach(c => c.classList.toggle('active', c.dataset.model === v));
    const summEl = $('summModel');
    if (summEl) summEl.textContent = mc.letter + ' — ' + mc.label;
    $('sideBRow').style.display = mc.sides.includes('B') ? 'flex' : 'none';
    $('sideCRow').style.display = mc.sides.includes('C') ? 'flex' : 'none';
    const srcCard = document.querySelector('.gr-model-card[data-model="' + v + '"]');
    const previewEl = $('modelSvgPreview');
    if (srcCard && previewEl) {
      const svg = srcCard.querySelector('svg');
      if (svg) previewEl.innerHTML = svg.outerHTML;
    }
    if (!S.modelGekozen) {
      S.modelGekozen = true;
      const ph = $('afmPlaceholder'); if (ph) ph.style.display = 'none';
      const det = $('afmDetails'); if (det) det.style.display = '';
    }
    closeModal('mModel');
    calc();
  }

  function setBevestiging(variantId, price, label, el) {
    S.steunVariantId = variantId ? parseInt(variantId) : null;
    S.steunPrijs = price || 0;
    S.steunLabel = label;
    document.querySelectorAll('#mBevestiging .gr-bev-item').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const shortLabel = label.split('—')[0].trim();
    const summEl = $('summBevestiging');
    if (summEl) summEl.textContent = shortLabel;
    if (!S.bevGekozen) {
      S.bevGekozen = true;
      const det = $('bevDetails'); if (det) det.style.display = '';
    }
    const advN = Math.ceil(getTotalLength() / 50) + 1;
    const steunenInputEl = $('steunenInput');
    if (steunenInputEl) steunenInputEl.value = advN;
    closeModal('mBevestiging');
    calc();
  }

  function setGlijderProduct(idx, el) {
    const gp = (P.glijder_producten || [])[idx];
    if (!gp) return;
    S.glijderProductIdx = idx;
    S.glijderType = gp.type || 'ks';
    S.glijderLabel = gp.title;
    const kleurAlts = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] };
    const alts = kleurAlts[S.kleur] || [S.kleur];
    const colorV = gp.variants && (
      gp.variants.find(v => { const vt = v.title.toLowerCase(); return alts.some(a => vt.includes(a)); }) ||
      gp.variants[0]
    );
    if (colorV) {
      S.glijderVariantId = colorV.id;
      S.glijderPrijs = colorV.price / 100;
    }
    S.glijderOpening = 'midden';
    setPills('pillsOpening', 'midden');
    document.querySelectorAll('#mGlijders .gr-bev-item[data-glidx]').forEach(i => i.classList.remove('active'));
    if (el) el.classList.add('active');
    const shortLabel = gp.title.split('—')[0].trim();
    const summEl = $('summGlijders');
    if (summEl) summEl.textContent = shortLabel;
    const advN = calcGlijderCount(getTotalLength() / 100);
    const glijdersInputEl = $('glijdersInput');
    if (glijdersInputEl) glijdersInputEl.value = advN;
    const advGlijdersEl = $('advGlijders');
    if (advGlijdersEl) advGlijdersEl.textContent = advN;
    if (!S.glijderGekozen) {
      S.glijderGekozen = true;
      const ph = $('glijderPlaceholder'); if (ph) ph.style.display = 'none';
      const det = $('glijderDetails'); if (det) det.style.display = '';
    }
    closeModal('mGlijders');
    calc();
  }

  function setOpening(v) {
    S.glijderOpening = v;
    const gp = (P.glijder_producten || [])[S.glijderProductIdx];
    if (gp && gp.variants) {
      const t = v.toLowerCase();
      const kleurAlts2 = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] };
      const alts2 = kleurAlts2[S.kleur] || [S.kleur];
      const matchesKleur = vv => { const vt = vv.title.toLowerCase(); return alts2.some(a => vt.includes(a)); };
      const variant = gp.variants.find(vv => matchesKleur(vv) && vv.title.toLowerCase().includes(t))
        || gp.variants.find(vv => matchesKleur(vv))
        || gp.variants[0];
      if (variant) { S.glijderVariantId = variant.id; S.glijderPrijs = variant.price / 100; }
    }
    setPills('pillsOpening', v);
    calc();
  }

  function toggleExtra() {
    const sec = $('extraSection');
    const btn = $('extraToggleBtn');
    const open = sec.style.display === 'none';
    sec.style.display = open ? 'block' : 'none';
    btn.textContent = open ? 'Extra opties verbergen' : 'Extra opties toevoegen';
  }

  function setPills(id, v) {
    document.querySelectorAll('#' + id + ' .gr-pill').forEach(p => p.classList.toggle('active', p.dataset.v === v));
  }

  function adj(f, d) {
    const ids = { steunen: 'steunenInput', ek: 'ekInput', glijders: 'glijdersInput', qty: 'qtyInput', vg: 'vgInput' };
    const el = $(ids[f]);
    if (!el) return;
    el.value = Math.max(parseInt(el.min) || 0, Math.min(parseInt(el.max) || 999, (parseInt(el.value) || 0) + d));
    calc();
  }

  function syncCI(itemId, ckId) {
    $(itemId)?.classList.toggle('on', $(ckId)?.checked || false);
  }

  /* ── CALC + PRICE BREAKDOWN ── */

  function calcGlijderCount(m) {
    if (S.glijderType === 'wave6') return Math.ceil(m * (S.glijderOpening === 'midden' ? 20 : 18));
    if (S.glijderType === 'wave8') return Math.ceil(m * (S.glijderOpening === 'midden' ? 18 : 14));
    return Math.ceil(m * 12);
  }

  function calc() {
    const mc = MODELS[S.model];
    const len = getTotalLength();
    const m = len / 100;
    const adv = Math.ceil(len / 50) + 1;

    // Update dimension display
    const meterVal = $('meterVal');
    if (meterVal) meterVal.textContent = nl2(m) + ' m';

    const railPrice = P.rail ? (P.rail[S.kleur]?.price || 22) / 100 : 0.22;
    const railP = len * railPrice;
    const railPrijsEl = $('railPrijsVal');
    if (railPrijsEl) railPrijsEl.textContent = nl2(m) + ' m · ' + fmt(railP);

    [$('advSteunen'), $('advSteunenBev')].forEach(el => { if (el) el.textContent = adv; });

    // Verbinder warning
    const needsV = len > 700;
    $('warnVerbinder')?.classList.toggle('show', needsV);
    const verbinderItem = $('ciVerbinder');
    if (verbinderItem) verbinderItem.style.display = needsV ? 'flex' : 'none';
    if (needsV && $('ckVerbinder')) { $('ckVerbinder').checked = true; syncCI('ciVerbinder', 'ckVerbinder'); }

    const verbP = needsV && $('ckVerbinder')?.checked ? (P.verbinder?.price ? P.verbinder.price / 100 : 7.50) : 0;
    const nSteunen = parseInt($('steunenInput')?.value) || adv;
    const steunP = nSteunen * S.steunPrijs;
    const nBochten = mc.bochten;
    const bochtenUnitPrice = P.bocht?.price ? P.bocht.price / 100 : 25;
    const bochtenP = nBochten * bochtenUnitPrice;

    const advG = calcGlijderCount(m);
    const advGlijdersEl = $('advGlijders');
    if (advGlijdersEl) advGlijdersEl.textContent = advG;
    const nG = parseInt($('glijdersInput')?.value) || advG;
    const gPPU = S.glijderPrijs || 0.37;
    const glijderP = nG * gPPU;
    const glijdersPEl = $('glijdersP');
    if (glijdersPEl) glijdersPEl.textContent = fmt(glijderP);

    const nEK = parseInt($('ekInput')?.value) || 2;
    const ekUnitPrice = P.eindkapje?.price ? P.eindkapje.price / 100 : 1.10;
    const ekP = nEK * ekUnitPrice;

    const ckA = $('ckAssemblage')?.checked || false;
    const ckL = $('ckLichtkier')?.checked || false;
    const ckM = $('ckMontage')?.checked || false;
    const montageUnitPrice = (P.montage?.price || 0) > 0 ? P.montage.price / 100 : 15;
    const montageMeters = Math.max(1, Math.ceil(m));
    const montP = ckM ? montageMeters * montageUnitPrice : 0;
    const montageRateEl = $('montageRate');
    if (montageRateEl) montageRateEl.textContent = fmt(montageUnitPrice);
    const montagePrijsEl = $('montagePrijs');
    if (montagePrijsEl) montagePrijsEl.textContent = S.modelGekozen ? fmt(montageMeters * montageUnitPrice) : '—';

    syncCI('ciAssemblage', 'ckAssemblage');
    syncCI('ciLichtkier', 'ckLichtkier');

    // Build price breakdown rows
    const sideA = Math.max(0, parseInt($('lengteAInput')?.value) || 0);
    const sideB = mc.sides.includes('B') ? Math.max(0, parseInt($('lengteBInput')?.value) || 0) : 0;
    const sideC = mc.sides.includes('C') ? Math.max(0, parseInt($('lengteCInput')?.value) || 0) : 0;
    let railLabel = len + ' cm rail';
    if (nBochten > 0) {
      const parts = ['A: ' + sideA + ' cm'];
      if (sideB) parts.push('B: ' + sideB + ' cm');
      if (sideC) parts.push('C: ' + sideC + ' cm');
      railLabel += ' (' + parts.join(', ') + ')';
    }

    const rows = [];
    let totaal = 0;

    const addRow = (label, price) => {
      rows.push({ label, price });
      totaal += price || 0;
    };

    if (S.modelGekozen) addRow(railLabel, railP + bochtenP);
    if (S.bevGekozen)   addRow(nSteunen + '× ' + S.steunLabel, steunP);
    if (S.glijderGekozen) addRow(nG + '× Glijder (' + (S.glijderLabel || 'Glijder') + ')', glijderP);
    addRow(nEK + '× Eindkapje', ekP);
    if (ckA) addRow('Assemblage', 9);
    if (ckL) addRow('Lichtkierverberger', 7.50);
    if (verbP) addRow('Railverbinder', verbP);
    if (ckM) addRow('Montageservice', montP);

    const osRows = $('osRows');
    if (osRows) {
      osRows.innerHTML = rows.map(r =>
        '<div class="gr-os-row"><span class="orl">' + r.label + '</span>' +
        '<span class="orp">' + fmt(r.price) + '</span></div>'
      ).join('');
    }

    const qtyVal = Math.max(1, parseInt($('qtyInput')?.value) || 1);
    const osTotaal = $('osTotaal');
    if (osTotaal) osTotaal.textContent = totaal > 0 ? fmt(totaal * qtyVal) : '—';

    updateAllSumms();
  }

  /* ── GALLERY ── */

  function galleryGo(idx) {
    const imgs = window.GR_IMAGES || [];
    if (!imgs.length) return;
    idx = Math.max(0, Math.min(imgs.length - 1, idx));
    window.GR_IMG_IDX = idx;
    const el = $('grMainImg');
    if (el) { el.src = imgs[idx]; el.srcset = ''; }
    document.querySelectorAll('.gr-thumb').forEach(function(t) {
      t.classList.toggle('active', parseInt(t.dataset.idx) === idx);
    });
    const prev = $('grArrPrev');
    const next = $('grArrNext');
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === imgs.length - 1;
  }

  function galleryNav(dir) {
    galleryGo((window.GR_IMG_IDX || 0) + dir);
  }

  /* ── MODALS ── */

  function openModal(id) {
    $(id)?.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (id === 'mBevestiging') filterBevestigingByColor(S.kleur);
    if (id === 'mGlijders') updateGlijderImages(S.kleur);
    if (id === 'mEindkapjes') updateEindkapjeImage(S.kleur);
  }
  function closeModal(id) {
    $(id)?.classList.remove('open');
    document.body.style.overflow = '';
  }
  function closeOnBg(e, id) { if (e.target === $(id)) closeModal(id); }

  /* ── ADD TO CART ── */

  async function addToCart() {
    const btn = $('addToCartBtn');
    if (!P.rail) { alert('Productdata niet geladen. Probeer de pagina te verversen.'); return; }

    btn.disabled = true;
    btn.textContent = 'Toevoegen…';

    const mc = MODELS[S.model];
    const len = getTotalLength();
    const m = len / 100;
    const adv = Math.ceil(len / 50) + 1;
    const nSteunen = parseInt($('steunenInput')?.value) || adv;
    const nBochten = mc.bochten;
    const nEK = parseInt($('ekInput')?.value) || 2;
    const needsV = len > 700;
    const nG = parseInt($('glijdersInput')?.value) || calcGlijderCount(m);

    const sideA = parseInt($('lengteAInput')?.value) || 0;
    const sideB = mc.sides.includes('B') ? (parseInt($('lengteBInput')?.value) || 0) : 0;
    const sideC = mc.sides.includes('C') ? (parseInt($('lengteCInput')?.value) || 0) : 0;

    const railVariantId = P.rail?.[S.kleur]?.id;
    const items = [];

    if (railVariantId) {
      const props = {
        'Model': mc.letter + ' — ' + mc.label,
        'Kleur': S.kleur[0].toUpperCase() + S.kleur.slice(1),
        'Zijde A': sideA + ' cm',
      };
      if (sideB) props['Zijde B'] = sideB + ' cm';
      if (sideC) props['Zijde C'] = sideC + ' cm';
      items.push({ id: railVariantId, quantity: len, properties: props });
    }

    if (S.steunVariantId && nSteunen > 0) {
      items.push({ id: S.steunVariantId, quantity: nSteunen, properties: { 'Type': S.steunLabel } });
    }

    if (P.bocht?.variantId && nBochten > 0) {
      items.push({ id: P.bocht.variantId, quantity: nBochten, properties: { 'Model': mc.label } });
    }

    if (S.glijderVariantId && nG > 0) {
      const props = {};
      if (S.glijderType !== 'ks') props['Richting'] = S.glijderOpening;
      items.push({ id: S.glijderVariantId, quantity: nG, properties: props });
    }

    if (S.ekWil && nEK > 0 && P.eindkapje) {
      const ekAlts = { zwart: ['zwart','black','noir'], wit: ['wit','white','blanc'] };
      const ekA = ekAlts[S.kleur] || [S.kleur];
      const ekV = (P.eindkapje.variants || []).find(v => { const vt = v.title.toLowerCase(); return ekA.some(a => vt.includes(a)); })
        || { id: P.eindkapje.variantId };
      if (ekV.id) items.push({ id: ekV.id, quantity: nEK });
    }

    if (needsV && P.verbinder?.variantId && $('ckVerbinder')?.checked) {
      items.push({ id: P.verbinder.variantId, quantity: 1 });
    }

    if ($('ckMontage')?.checked && P.montage?.variantId) {
      const montageM = Math.max(1, Math.ceil(len / 100));
      items.push({ id: P.montage.variantId, quantity: montageM });
    }

    const qty = Math.max(1, parseInt($('qtyInput')?.value) || 1);
    if (qty > 1) items.forEach(item => { item.quantity = item.quantity * qty; });

    if (items.length === 0) {
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
      alert('Selecteer eerst een model en vul de afmetingen in.');
      return;
    }

    console.log('Cart items:', JSON.stringify(items, null, 2));

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.error('Cart error response:', errData);
        throw new Error(errData.description || errData.message || 'Cart error ' + res.status);
      }
      window.location = '/cart';
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Toevoegen aan winkelwagen';
      alert('Er is iets misgegaan: ' + err.message);
    }
  }

  /* ── INIT ── */

  window.GR = {
    setKleur, setModel, setBevestiging, setGlijderProduct, setEindkapje, setMontage,
    setOpening, adj, syncCI, openModal, closeModal, closeOnBg,
    addToCart, calc, galleryGo, galleryNav,
    toggleStep, confirmStep,
  };

  function init() {
    setModel('recht');
    S.modelGekozen = false;
    const afmDet = $('afmDetails'); if (afmDet) afmDet.style.display = 'none';
    const summModel = $('summModel'); if (summModel) summModel.textContent = '—';
    const preview = $('modelSvgPreview'); if (preview) preview.innerHTML = '';

    S.bevGekozen = false;
    const bevDet = $('bevDetails'); if (bevDet) bevDet.style.display = 'none';

    S.glijderGekozen = false;
    const glDet = $('glijderDetails'); if (glDet) glDet.style.display = 'none';

    S.ekGekozen = false;
    const ekDet = $('ekDetails'); if (ekDet) ekDet.style.display = 'none';

    filterBevestigingByColor(S.kleur);
    updateGlijderImages(S.kleur);

    calc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
